<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">اطلاعات  پیام نامه</h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">عنوان</label>
        <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button  type="button" (click)="ReadData_MailMessage()" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button routerLink="/MailMessageAdd" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>عنوان</th>
              <th>متن</th>
              <th>نوع نامه</th>
              <th>پیش پرداخت</th>
              <th>تاریخ</th>
              <th>کاربر</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_MailMessage
            |filter:Filter_title:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_MailMessage|filter:Filter_title:'title').length
                      }
            ">
             <td>{{DataList_MailMessage.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.code}}</td>
              <td *ngIf="item.letterType==1">نامه صادره</td>
              <td *ngIf="item.letterType==2">رسید امانت</td>
              <td *ngIf="item.letterType==3">دریافت دستگاه</td>
              <td *ngIf="item.letterType==4">نامه زمان بندی</td>

              <td *ngIf="item.pishPardakht==true" style="color: #489b39;">بله</td>
              <td *ngIf="item.pishPardakht==false" style="color: red;">خیر</td>

              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                      <a *ngIf="item.pishPardakht==false" style="cursor: pointer;" class="dropdown-item" (click)="openModal(templatePishPardakht,item)"><i class="fa fa-check"></i> پیش پرداخت </a>
                      <a *ngIf="item.pishPardakht==true" style="cursor: pointer;" class="dropdown-item" (click)="openModal(templatePishPardakht,item)"><i class="fa fa-times-circle"></i> عدم پیش پرداخت </a>

                      <a  style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> حذف </a>
                    </div>
                </div>

                <div *ngIf="item.DeletingProccess" >
                  <img  src="assets/Loading.gif" style="width: 25px;" />
                </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_FeildTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4   class="modal-title pull-left">تایید حذف اطلاعات  پیام نامه '{{Data_Seleted_Delete.title}}' </h4>

     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button   type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> حذف اطلاعات <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templatePishPardakht>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.pishPardakht==false"  class="modal-title pull-left">تایید پیش پرداخت  '{{Data_Seleted_Delete.title}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete.pishPardakht==true" class="modal-title pull-left">تایید عدم پیش پرداخت  '{{Data_Seleted_Delete.title}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeletePishPardakht.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.pishPardakht==false"  type="button" class="btn btn-warning" (click)="PishPardakht(Data_Seleted_Delete)"> پیش پرداخت <i class="fa fa-check"></i></button>
    <button *ngIf="Data_Seleted_Delete.pishPardakht==true" type="button" class="btn btn-warning" (click)="PishPardakht(Data_Seleted_Delete)"> عدم پیش پرداخت <i class="fa fa-times-circle"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DeletePishPardakht.hide()">بستن</button>
  </div>
</ng-template>
